import styled from "styled-components";

export const Column = styled.div<{
  $full?: boolean;
  $gap?: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${({ $full }) => ($full ? "100%" : "default")};
  gap: ${({ $gap = 0 }) => $gap}px;
`;
